import Statistics from "./Statistics";

export default class GlobalStatistics extends Statistics {
    constructor() {
        super();
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetForPrestige() {
        // Do nothing for prestige reset. Do not let child class reset things.
    }

}